export const roleUser = {
  user: "editor-user",
  it: "editor-it",
  admin: "admin-it",
  superadmin: "superadmin-it",
};
